import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentRoom6 } from "./ContentRoom6"
import { ContentRoom5 } from "./ContentRoom5"
import { Balloon } from "./Balloon"
import { Help } from "./Help"

import "./../assets/scss/Room6.scss";


export const Room6 = (props) => {

  const steps = {
    "b_intro" : ["intro", ""],
    "f_marge1" : ["", ""],
    "b_marge1a" : ["right", "follow"],
    "f_rover" : ["", ""],
    "f_marge2" : ["", ""],
    "b_marge2a" : ["right", "follow"],
    "f_trapano" : ["", ""],
    "b_trapano" : ["slide link", "close"],
    "f_cruciverba" : ["", ""],
    "b_cruciverba" : ["image link", "close"],
    "risposta" : ["", ""],
    "b_exit" : ["exit", ""]
  };

  const handleLinkRovere = () => {
    window.open('https://3dviewer.net/index.html#model=https://escapemarte.museoscienza.it/nasa/model.glb', '_blank', 'noopener,noreferrer');
    props.onChangeStep(Object.keys(steps).indexOf("f_marge2"));
  }

  React.useEffect(() => {
    if(props.step == Object.keys(steps).indexOf("risposta")) props.onNextHelp();
  }, [props.step]);

  const stars = [];

  for (let i = 0; i < 20; i++) {
    stars.push(<div className="star" key={i}  />);
  }

    return(
      <div className="room6">

        <div className="parete">
          <div className="schermo">
            <ContentRoom6 stringToRet="luna" />
            <div className="stars">{stars}</div>
            <div className="satellite">
              <ContentRoom5 stringToRet="satellite" />
            </div>
          </div>
          <div className="schermo">
            <div className="terra">
              <ContentRoom6 stringToRet="terra" />
            </div>
            <div className="stars">{stars}</div>
          </div>
          <div className="schermo">
            <div className="stars">{stars}</div>
            <ContentRoom6 stringToRet="suolo" />

            <button className={`rover
                ${(props.step >= Object.keys(steps).indexOf("f_rover")) ? "active" : "unactive"}`}
                onClick={props.step >= Object.keys(steps).indexOf("f_rover") ? handleLinkRovere : () => false }>
              {(props.step == Object.keys(steps).indexOf("f_rover")) &&
                <CommonSvgContent stringToRet="click" />
              }
              {(props.step > Object.keys(steps).indexOf("f_rover")) &&
                <div className="clickable" />
              }
              <ContentRoom6 stringToRet="rover" />
            </button>
          </div>
        </div>
        <div className="desktops">
          <div className="desktop up">
            <ContentRoom6 stringToRet="strum1a" />
            <ContentRoom6 stringToRet="strum2a" />
            <div className="customBlock">
              <div className="verticalWrapper">
                <div className="vertBg"></div>
                <div className="vertCursor"></div>
              </div>
              <div className="orizontals">
                <div className="orizBlock" />
                <div className="orizBlock" />
                <div className="orizBlock" />
                <div className="orizBlock" />
                <div className="orizBlock" />
              </div>
            </div>
            <ContentRoom6 stringToRet="strum3a" />
            <ContentRoom6 stringToRet="strum4a" />
            <ContentRoom6 stringToRet="strum5a" />
            <ContentRoom6 stringToRet="strum6a" />
            <ContentRoom6 stringToRet="strum7a" />
          </div>
          <div className="desktop bottom">

            <button className={`cruciverba
                ${(props.step >= Object.keys(steps).indexOf("f_cruciverba")) ? "active" : "unactive"}`}
                onClick={() => props.step >= Object.keys(steps).indexOf("f_cruciverba") ? props.onChangeStep(Object.keys(steps).indexOf("b_cruciverba")) : false }>
              {(props.step == Object.keys(steps).indexOf("f_cruciverba")) &&
                <CommonSvgContent stringToRet="click" />
              }
              {(props.step > Object.keys(steps).indexOf("f_cruciverba")) &&
                <div className="clickable" />
              }
              <table>
              <tbody>
                <tr><td>C</td><td>E</td><td>!</td><td>C</td><td>E</td><td>F</td></tr>
                <tr><td>B</td><td>F</td><td>R</td><td>M</td><td>A</td><td>I</td></tr>
                <tr><td>U</td><td>I</td><td>T</td><td>E</td><td>A</td><td>?</td></tr>
                <tr><td>z</td><td>L</td><td>L</td><td>N</td><td>A</td><td>X</td></tr>
                <tr><td>?</td><td>Z</td><td>A</td><td>!</td><td>I</td><td>L</td></tr>
                <tr><td>H</td><td>U</td><td>E</td><td>M</td><td>A</td><td>R</td></tr>
              </tbody>
              </table>
            </button>

            <div className="customBlock">
              <div className="verticalWrapper">
                <div className="vertBg"></div>
                <div className="vertCursor"></div>
              </div>
              <div className="orizontals">
                <div className="orizBlock" />
                <div className="orizBlock" />
                <div className="orizBlock" />
                <div className="orizBlock" />
                <div className="orizBlock" />
              </div>
            </div>
            <ContentRoom6 stringToRet="strum1b" />
            <ContentRoom6 stringToRet="strum2b" />
            <ContentRoom6 stringToRet="strum3b" />
            <ContentRoom6 stringToRet="strum4b" />
            <ContentRoom6 stringToRet="strum5b" />
            <button className={`trapano
                ${(props.step >= Object.keys(steps).indexOf("f_trapano")) ? "active" : "unactive"}`}
                onClick={() => props.step >= Object.keys(steps).indexOf("f_trapano") ? props.onChangeStep(Object.keys(steps).indexOf("b_trapano")) : false }>
              {(props.step == Object.keys(steps).indexOf("f_trapano")) &&
                <CommonSvgContent stringToRet="click" />
              }
              {(props.step > Object.keys(steps).indexOf("f_trapano")) &&
                <div className="clickable" />
              }

              <div className="trapanoMap"></div>
              <div className="qrcodes">
                <div className="qrcode"></div>
                <div className="qrcode"></div>
                <div className="qrcode"></div>
                <div className="qrcode"></div>
                <div className="qrcode"></div>
              </div>
            </button>
          </div>
        </div>

        <div className="pavimento">
          <ContentRoom6 stringToRet="pavimento" />
        </div>

        <div className={`areaTelefono ${(props.step == Object.keys(steps).indexOf("risposta")) ? "help3 ringing" : ""}`}>
          <div className="pianoUnder" />
          <div className="pianoOver">
            <button className={`telefono
                ${(props.step >= Object.keys(steps).indexOf("f_help")) ? "active" : "unactive"}`}
                onClick={() => props.step >= Object.keys(steps).indexOf("f_help") ? props.onChangeStep(Object.keys(steps).indexOf("b_help")) : false }>
              <CommonSvgContent stringToRet="telefono" />
              {(props.step == Object.keys(steps).indexOf("f_help")) &&
                <CommonSvgContent stringToRet="click" />
              }
            </button>

            <div className="helpsWrapper">
              <div className="helps">
              <button className="helpclick1 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 1) : false }>1</button>
              <button className="helpclick2 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 2) : false }>2</button>
              <button className="helpclick3 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 3) : false }>3</button>
              </div>
            </div>
          </div>
        </div>

        <button
          className={`marge ${(props.step >= Object.keys(steps).indexOf("f_marge1")) ? "active" : "unactive"}`}
          onClick={() => props.step >= Object.keys(steps).indexOf("f_marge1") &&  props.step < Object.keys(steps).indexOf("f_marge2") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge1a")) :
                         props.step >= Object.keys(steps).indexOf("f_marge2") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge2a")) : false } >
          {(props.step == Object.keys(steps).indexOf("f_marge1") ||
            props.step == Object.keys(steps).indexOf("f_marge2")) &&
            <CommonSvgContent stringToRet="click" />
          }
          {(props.step > Object.keys(steps).indexOf("f_marge1")) &&
            <div className="clickable" />
          }
          <CommonSvgContent stringToRet="marge" />
        </button>

        {(props.step == Object.keys(steps).indexOf("risposta")) &&
          <div className="risposta">
            {(props.answerfeedback == "wrong") && (<div className="wrong"><p>La password non è corretta</p></div>)}

            <div className="rispostaCont">
              <form onSubmit={(e) => props.onSubmitAnswer(e, "room6", Object.keys(steps).indexOf("risposta"))}>
                <input type="text" placeholder="" value={props.answer} onChange={(e) => props.onChangeAnswer(e)} />
                <input type="submit" value="OK" />
              </form>
              <p>12 caratteri</p>
            </div>
          </div>
        }

        {(props.helpopen != 0) &&
          <Help room={props.room} clickon={`help${props.helpopen}`} onNextHelp={props.onNextHelp} />
        }

        {(Object.keys(steps).length > props.stepnow && Object.keys(steps)[props.stepnow].startsWith("b_")) &&
          <Balloon type={steps[Object.keys(steps)[props.stepnow]][0]} room={props.room} clickon={Object.keys(steps)[props.stepnow]} button={steps[Object.keys(steps)[props.stepnow]][1]} interaction={false} onChangeStep={props.onChangeStep} onChangeStep={props.onChangeStep} onChangeRoom={props.onChangeRoom} />
        }

      </div>
    )
}
